import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api/api.service';
import { IPreCheckinFormCustomization } from '@precheckin/models/precheckin-form-customization/precheckin-form-customization.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PreCheckinFormCustomizationService {
  private readonly endpoint = `visits`;

  constructor(private apiService: ApiService) { }

  public getCheckinFormFieldsByTrainingCenterId(trainingCenterId: string): Observable<IPreCheckinFormCustomization> {
    return this.apiService.get<IPreCheckinFormCustomization>(
      `${this.endpoint}/checkin-form-fields?trainingCenterId=${trainingCenterId}`
    )
  }
}